'use strict';

class CuentaBeneficiarioController {
  constructor($log, $scope, DataService, Message, Util, Loading) {
    'ngInject';
    this.$log = $log;
    this.$scope = $scope;
    this.DataService = DataService;
    this.Message = Message;
    this.Util = Util;
    this.Loading = Loading;
    this.listaProductos = [];
    this.dataProducto = {};
    this.conf = {};
    this.cuenta = '';
  }
  $onInit() {
    this.cargarMoneda();
    this.cargarTipoCuenta();
    this.cargarDepartamentos();
  }
  cancel() {
    // this.insertaNuevo = false;
  }
  cargarMoneda() {
    var url = `parametros/?grupo=CUENTA_MONEDA`;
    this.DataService.get(url)
    .then((response) => {
      this.monedas = response;
    });
  }
  cargarTipoCuenta() {
    var url = `parametros/?grupo=TIPO_CUENTA`;
    this.DataService.get(url)
    .then((response) => {
      this.tiposCuenta = response;
    });
  }
  cargarDepartamentos() {
    var url = `parametros/?grupo=DEPARTAMENTO_MEF`;
    this.DataService.get(url)
    .then((response) => {
      if (response) {
        this.departamentos = response;
        this.departamentos = this.departamentos.filter(item => item.sigla !== '99');
      }
    });
  }
}

export default CuentaBeneficiarioController;



// WEBPACK FOOTER //
// ./src/app/common/core/util/forms/cuentaBeneficiario/cuentaBeneficiario.controller.js